import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Parameter, PayHubCashierContractsViewDataResponse } from 'store/models';

export interface CardData {
  pan?: string;
  month?: string;
  year?: string;
  cvv?: string;
  cardholder?: string;
  save_card?: boolean;
  card_id?: number;
  [key: string]: string | boolean | number | undefined;
}

export interface RoutingPayloadH2H {
  amount: number;
  currency: string;
  paygroup_id: number;
  card_data?: CardData;
  [key: string]: string | number | CardData | undefined;
}

interface RoutingState {
  parameters: Parameter[];
  view_data: PayHubCashierContractsViewDataResponse[];
  card_data: CardData;
  payloadH2H: RoutingPayloadH2H | null;
  routingChangedWorkFlow: string;
}

const initialState: RoutingState = {
  parameters: [],
  view_data: [],
  card_data: {},
  payloadH2H: null,
  routingChangedWorkFlow: '',
};

export const routingSlice = createSlice({
  name: 'routing',
  initialState,
  reducers: {
    setRoutingParameters: (
      state,
      action: PayloadAction<{
        parameters: Parameter[];
        view_data: PayHubCashierContractsViewDataResponse[];
      }>,
    ) => ({
      ...state,
      parameters: action.payload.parameters,
      view_data: action.payload.view_data,
    }),
    setRoutingCardData: (state, action: PayloadAction<CardData>) => ({
      ...state,
      card_data: action.payload,
    }),
    setRoutingPayloadH2H: (state, action: PayloadAction<RoutingPayloadH2H>) => ({
      ...state,
      payloadH2H: action.payload,
    }),
    setRoutingChangedWorkFlow: (state, action: PayloadAction<string>) => ({
      ...state,
      routingChangedWorkFlow: action.payload,
    }),
  },
});

export const getRoutingParametersSelector = (state: { routing: RoutingState }) => state.routing.parameters;

export const getRoutingViewDataSelector = (state: { routing: RoutingState }) => state.routing.view_data;

export const getRoutingCardDataSelector = (state: { routing: RoutingState }) => state.routing.card_data;

export const getRoutingPayloadH2HSelector = (state: { routing: RoutingState }) => state.routing.payloadH2H;

export const getRoutingChangedWorkFlowSelector = (state: { routing: RoutingState }) =>
  state.routing.routingChangedWorkFlow;

export const { setRoutingParameters, setRoutingCardData, setRoutingPayloadH2H, setRoutingChangedWorkFlow } =
  routingSlice.actions;

export default routingSlice.reducer;
